export const HOMEPAGE_CONTENT_LOAD = 'HOMEPAGE_CONTENT_LOAD';
export const HOMEPAGE_CONTENT_LOADED = 'HOMEPAGE_CONTENT_LOADED';
export const HOMEPAGE_SET_MESSAGES = 'HOMEPAGE_SET_MESSAGES';
export const HOMEPAGE_UNSET_MESSAGES = 'HOMEPAGE_UNSET_MESSAGES';
